// BalanceBars — per-fund transferable balance with a proportional bar and the
// dollar/percent readout. Screen-specific to Transfer Funds.
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../utils/format';

export function BalanceBars({ balances, total }) {
  return (
    <div className="ma-xfer-stack">
      {balances.map((b) => (
        <div key={b.ticker} className="ma-xfer-row">
          <span className="ma-fund-dot" style={{ background: b.color }} aria-hidden="true" />
          <div className="ma-xfer-id">
            <div className="ma-xfer-tkr">{b.ticker}</div>
            <div className="ma-xfer-nm">{b.name}</div>
          </div>
          <div className="ma-xfer-bar">
            <span style={{ width: `${total ? (b.balance / total) * 100 : 0}%`, background: b.color }} />
          </div>
          <div className="ma-xfer-bal">
            <div className="ma-xfer-bal-val">{formatCurrency(b.balance, false)}</div>
            <div className="ma-xfer-bal-pct">{b.pct}%</div>
          </div>
        </div>
      ))}
    </div>
  );
}

BalanceBars.propTypes = {
  balances: PropTypes.arrayOf(
    PropTypes.shape({
      ticker: PropTypes.string,
      name: PropTypes.string,
      balance: PropTypes.number,
      pct: PropTypes.number,
      color: PropTypes.string,
    }),
  ).isRequired,
  total: PropTypes.number.isRequired,
};

export default BalanceBars;
